module.exports = __webpack_public_path__ + "static/media/Ex2-S5-ToolAns.5e9c5235.png";